import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';

import {
  adexMatchingList,
  adexMatchingModify,
  adexMatchingModifies,
  adexMatchingAdd,
  getAdexUserList,
} from 'lib/api/adex';

import FilterWrap from 'components/atoms/FilterWrap';
import NewInput from 'components/atoms/NewInput';
import NewButton from 'components/molecules/NewButton';
import TableContainer from 'components/molecules/MbTable';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import Popover from 'components/molecules/Popover';
import SnackbarWrap from 'components/organisms/Snackbar/SnackbarWrap';
import Modal from 'components/organisms/NewModal';
import LabelFilterWrap from 'components/molecules/LabelFilterWrap';
import FilterCollection from 'components/organisms/FilterCollection';

const useStyles = makeStyles((theme) => ({
  textfiled: {
    width: 250,
    '& input': {
      padding: '8px 14px',
    },
  },
}));

let closePopover = null;
const Matching = (props) => {
  let intitParams = {};
  const classes = useStyles();
  const { t } = useTranslation();
  const [initialization, setInitialization] = useState(false);
  const { sendTpCode } = props;
  intitParams = {
    uri: '/product/adex/matching',
    sendTpCode: sendTpCode,
    advrtsPrdtCode: null,
    externalId: null,
    pltfomTpCode: null,
    state: null,
    zoneId: null,
    keyword: null,
  };
  const initSnackbar = {
    state: false,
    variant: 'success',
    message: '',
  };
  const initError = {
    externalId: {
      state: false,
      helperText: '',
    },
    mediaScriptNo: {
      state: false,
      helperText: '',
    },
    zoneId: {
      state: false,
      helperText: '',
    },
  };
  const [params, setParams] = useState(intitParams);
  const [snackbar, setSnackbar] = useState(initSnackbar);
  const [error, setError] = useState(initError);
  const [userFilterList, setUserFilterList] = useState([]);

  const initModal = {
    open: false,
    params: {
      externalId: '',
      sendTpCode: sendTpCode,
      mediaScriptNo: '',
      mediaId: '',
      memo: '',
    },
    disable: '',
  };
  const [modal, setModal] = useState(initModal);
  const [reGetData, setReGetData] = useState(false);

  useEffect(() => {
    if (reGetData === true) {
      setReGetData(false);
    }
  }, [reGetData]);

  useEffect(() => {
    getAdexUserData();
  }, []);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  useEffect(() => {
    setInitialization(false);
  }, [params]);

  // header 및 body 컬럼 커스텀
  const customized = {
    STATE: {
      makeHead: (headsMap) => {
        return <>게재상태</>;
      },
      makeBody: (rowObj, headsMap) => {
        return (
          <>
            <NewButton
              title={t('광고 on/off')}
              icon="faPowerOff"
              iconBtn
              onClick={() => handleStateToggle(rowObj)}
              style={rowObj.STATE === 'Y' ? { backgroundColor: '#79bd2f' } : {}}
              color={rowObj.STATE === 'Y' ? '#fff' : undefined}
            />
          </>
        );
      },
    },
    MEMO: {
      makeBody: (rowObj, headsMap) => {
        let memo = rowObj.MEMO;
        if (rowObj.MEMO === null) {
          memo = '';
        }
        return (
          <>
            <NewInput
              className={classes.textfiled}
              type={'tableInput'}
              placeholder="메모 입력 후 'ENTER'를 눌러주세요."
              value={memo}
              onKeyPress={(e) => handleMemoKeyPress(e, rowObj)}
            />
          </>
        );
      },
    },
    NO: {
      merged: true,
    },
  };

  const handleStateToggle = (rowData) => {
    const { EXL_NO, STATE } = rowData;
    let tempParams = {
      sendTpCode: sendTpCode,
      exlNo: EXL_NO,
      state: STATE === 'Y' ? '02' : STATE === 'N' && '01',
    };
    handleAdexTransMatchingModify(tempParams);
  };

  const handleAdexTransMatchingModify = (tempParams) => {
    adexMatchingModify(tempParams)
      .then((response) => {
        setSnackbar({
          ...initSnackbar,
          state: true,
          variant: 'success',
          message: response.data.message,
        });
        setReGetData(true);
      })
      .catch((error) => {
        setSnackbar({
          ...initSnackbar,
          state: true,
          variant: 'error',
          message: error,
        });
        setReGetData(false);
      });
  };

  /**
   * 스낵바 닫는 함수
   * 연속 클릭이 들어왔을 때는 기존 스낵바를 유지
   * @param event
   * @param reason
   */
  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    let newSnackbar = {
      ...snackbar,
      state: false,
      message: '',
    };
    setSnackbar(newSnackbar);
  };

  /**
   * 지면등록함수
   */
  const handleSubmit = () => {
    console.log('modal.params.', modal.params);
    console.log('error', error);
    if (modal.params.externalId === '' || modal.params.externalId === null) {
      handleModalClose();
      setSnackbar({
        ...initSnackbar,
        state: true,
        variant: 'error',
        message: '연동 플렛폼 선택은 필수입니다.',
      });
      // setError({
      //   ...initError,
      //   externalId: {
      //     state: true,
      //     helperText: '연동플렛폼 선택은 필수입니다.',
      //   },
      // });
      return false;
    } else {
      //setError(initError);
    }

    if (modal.params.zoneId === '' || modal.params.zoneId === null) {
      setError({
        ...initError,
        zoneId: {
          state: true,
          helperText: '존 아이디 입력은 필수입니다.',
        },
      });
      return false;
    } else {
      setError(initError);
    }
    if (
      modal.params.mediaScriptNo === '' ||
      modal.params.mediaScriptNo === null
    ) {
      setError({
        ...initError,
        mediaScriptNo: {
          state: true,
          helperText: '매체 스크립트 번호 입력은 필수입니다.',
        },
      });
      return false;
    } else {
      setError(initError);
    }

    adexMatchingAdd(modal.params)
      .then((response) => {
        setSnackbar({
          ...initSnackbar,
          state: true,
          variant: 'success',
          message: response.data.message,
        });
        setReGetData(true);
      })
      .catch((error) => {
        setSnackbar({
          ...initSnackbar,
          state: true,
          variant: 'error',
          message: error,
        });
        setReGetData(false);
      });

    handleModalClose();
  };

  const handleModalOpen = () => {
    setModal({
      ...modal,
      open: true,
      headerTitle: '지면 등록',
    });
  };

  const handleModalClose = () => {
    setModal(initModal);
  };

  /**
   * 테이블 input 수정처리 함수
   * @param e
   * @param props
   */
  const handleMemoKeyPress = (e, props) => {
    if (e.charCode === 13) {
      let tempParams = {
        sendTpCode: sendTpCode,
        exlNo: props.EXL_NO,
        memo: e.target.value + '',
      };
      handleAdexMatchingModify(tempParams);
    }
  };

  /**
   * 테이블 input API처리 함수
   * @param tempParams
   */
  const handleAdexMatchingModify = (tempParams) => {
    adexMatchingModify(tempParams)
      .then((response) => {
        setSnackbar({
          ...initSnackbar,
          state: true,
          variant: 'success',
          message: response.data.message,
        });
        setReGetData(true);
      })
      .catch((error) => {
        alert(error);
      });
  };

  const childColumnSet = {
    STATS_DTTM: () => {
      return null;
    },
  };

  /**
   * 테이블 클릭 후 세부정보 받아올때 보낼 param setting 해주는 함수
   * @param {json} data 테이블 로우 데이터
   */
  const makeSubParam = (data) => {
    return {
      statsDttm: data.STATS_DTTM,
    };
  };

  /**
   * 필터창 닫는 핸들링 받아오는 함수
   */
  const getOnClose = (handleClose) => {
    closePopover = handleClose;
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(intitParams);
  };

  const getParam = (newParams) => {
    setParams({ ...params, ...newParams });
  };

  /**
   * 모달 셀렉트박스 선택함수
   * @param params
   */
  const handleSelectChange = (params) => {
    const { externalId } = params;
    let newModal = {};
    newModal = {
      ...modal,
      params: {
        ...modal.params,
        externalId: externalId,
      },
    };
    setModal(newModal);
  };

  /**
   * 라디오박스 옵션변경시
   * @param e
   */
  const handleOptionChange = (e) => {
    const { name, value } = e.target;
    const targetValue = value === '' ? null : value;
    const newParams = {
      ...params,
      [name]: targetValue,
    };
    setParams(newParams);
    closePopover();
  };

  /**
   * 모달 데이터 변경했을 때 실행되는 함수
   * @param newParams
   */
  const modalGetParam = (newParams) => {
    setModal({
      ...modal,
      params: {
        ...modal.params,
        ...newParams,
      },
    });
  };

  /**
   * 체크박스 Btn Callback 함수
   * @param type String (엑션타입)
   * @param rowData Array ( rowData)
   */
  const handleCheckBtnController = (type, data) => {
    let tmpExlNo = [];
    data.forEach(function (rowData) {
      tmpExlNo.push(rowData.EXL_NO);
    });

    let params = {};
    if (type === 'start') {
      params = {
        sendTpCode: sendTpCode,
        state: '01',
        exlNos: tmpExlNo.join(),
      };
    } else if (type === 'stop') {
      params = {
        sendTpCode: sendTpCode,
        state: '02',
        exlNos: tmpExlNo.join(),
      };
    }

    adexMatchingModifies(params)
      .then((response) => {
        setSnackbar({
          ...initSnackbar,
          state: true,
          variant: 'success',
          message: response.data.message,
        });
        setReGetData(true);
      })
      .catch((error) => {
        alert(error);
      });
  };

  /**
   * 연동플렛폼 리스트 받아오는 함수
   */
  const getAdexUserData = () => {
    getAdexUserList()
      .then((response) => {
        const { data } = response.data;
        setUserFilterList(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useDate={false}
          useExternalFilter={false}
          useMediaTpCode={true}
        />
        <Popover
          name="state"
          label={t('상태')}
          getOnClose={getOnClose}
          selectedLabel={t(
            params.state === '01'
              ? '게재중'
              : params.state === '02'
              ? '중지'
              : '전체'
          )}
          filtered={params.state !== ''}
          filterType="radio"
          optionSelectedValue={params.state ? params.state : ''}
          optionList={[
            { label: '전체', value: '' },
            { label: '게재중', value: '01' },
            { label: '중지', value: '02' },
          ]}
          optionOnChange={handleOptionChange}
        />
        <LabelFilterWrap onClick={handleModalOpen} label={t('등록')} />
      </FilterWrap>
      <TableContainer
        dataReqPromise={adexMatchingList}
        params={{ ...params }}
        getParam={getParam}
        dense
        customized={customized}
        hasExcel
        makeSubParam={makeSubParam}
        childColumnSet={childColumnSet}
        reGetData={reGetData}
        toolTip={t(
          '스크립트 OFF 하면 API 자동 OFF / 재 진행 시엔 API 수동으로 게재해야 함'
        )}
        hasCheckbox={true}
        hasActController={{
          start: true,
          stop: true,
        }}
        headCallBack={handleCheckBtnController}
      />

      <Modal
        open={modal.open}
        headerTitle={modal.headerTitle}
        handleClose={handleModalClose}
        confirmBtnOpen
        confirmOnClick={handleSubmit}
        // toolTip={
        //   '매체 아이디로 등록 시: 매체 사이트 및 지면 모두 게재 중인 모든 지면'
        // }
      >
        <table>
          <tbody>
            <tr>
              <th>* {t('연동 플렛폼')}</th>
              <td>
                <FilterCollection
                  label={t('연동플렛폼')}
                  name="externalId"
                  type="select"
                  usePopover={true}
                  labelKey="CORP_NAME"
                  valueKey="USER_ID"
                  list={userFilterList}
                  params={params}
                  callBack={handleSelectChange}
                  useSubmit
                  submitTitle={t('확인')}
                  error={error.externalId.state}
                  helperText={error.externalId.helperText}
                />
              </td>
            </tr>
            <tr>
              <th>* {t('존 아이디')}</th>
              <td>
                <NewInput
                  name="zoneId"
                  //disabled={modal.disable === 'mediaId' ? true : false}
                  callBack={modalGetParam}
                  value={modal.params.zoneId}
                  error={error.zoneId.state}
                  helperText={error.zoneId.helperText}
                />
              </td>
            </tr>
            <tr>
              <th>* {t('매체 스크립트 번호')}</th>
              <td>
                <NewInput
                  name="mediaScriptNo"
                  //disabled={modal.disable === 'mediaScriptNo' ? true : false}
                  //onBlur={handleInput}
                  callBack={modalGetParam}
                  error={error.mediaScriptNo.state}
                  helperText={error.mediaScriptNo.helperText}
                  value={modal.params.mediaScriptNo}
                />
              </td>
            </tr>
            <tr>
              <th>{t('메모')}</th>
              <td>
                <NewInput
                  name="memo"
                  className={`isPopup ${classes.textField}`}
                  classes={{
                    notchedOutline: classes.border,
                  }}
                  callBack={modalGetParam}
                  value={modal.params.memo}
                  multiline
                />
              </td>
            </tr>
          </tbody>
        </table>
      </Modal>

      <SnackbarWrap
        open={snackbar.state}
        onClose={handleSnackBarClose}
        variant={snackbar.variant}
        message={snackbar.message}
      />
    </>
  );
};

export default Matching;
